import React, { createContext, useContext, useState, useCallback } from 'react';
import SetEndDateModal from '../components/SetEndDateModal';

const EndDateModalContext = createContext();

export const useEndDateModal = () => {
  const context = useContext(EndDateModalContext);
  if (!context) {
    throw new Error('useEndDateModal must be used within an EndDateModalProvider');
  }
  return context;
};

// Single, app-wide "Set end-date" modal. Only one tenant's modal can be open
// at a time; it is rendered once here (portaled to <body> by SetEndDateModal)
// so it is always centered on the viewport regardless of the trigger's position.
export const EndDateModalProvider = ({ children }) => {
  const [state, setState] = useState({ organization: null, onSaved: null });

  const openEndDateModal = useCallback((organization, onSaved) => {
    setState({ organization, onSaved: onSaved || null });
  }, []);

  const closeEndDateModal = useCallback(() => {
    setState({ organization: null, onSaved: null });
  }, []);

  return (
    <EndDateModalContext.Provider value={{ openEndDateModal, closeEndDateModal }}>
      {children}
      <SetEndDateModal
        open={!!state.organization}
        organization={state.organization}
        onClose={closeEndDateModal}
        onSaved={state.onSaved}
      />
    </EndDateModalContext.Provider>
  );
};
